module.exports = __webpack_public_path__ + "static/media/upload-black.ab296e6e.svg";